<template>
    <Modal>
        <template #title>System info</template>

        <h2 class="color-red">Warning!</h2>

        <p>
            Please save and exit your work. Trim Designer will be updated.
            <br>
            You have <b>3 minutes</b>.
        </p>

        <template #footer>
            <Button style="width: 100px" @click="closeModal">Ok</Button>
        </template>
    </Modal>
</template>

<script>
    import Modal from "../../components/Modal";
    import Button from "../../components/Button";

    export default {
        name: "ServerWillBeOffNotificationModal",

        components: {
            Button,
            Modal,
        },

        methods: {
            closeModal() {
                this.$emit('closeModal');
            },

        },

    }
</script>

<style>

</style>